import React from 'react'
import Terminal from 'react-console-emulator'
import { Typewriter } from 'react-simple-typewriter'


const commands = {
	whoami: {
		description: "Un poco sobre mí 🙋.",
		fn: () => {
			return (`Nacido en Argentina en 1992. Fui a la Universidad Católica Argentina y me recibí de Abogado en 2017. \n
							 Mientras estudiaba y después de haberme graduado, trabajé en los sectores privado y público, y me cansé. Me parecía demasiado anticuada y muy poco satisfactoria la forma de trabajar y desarrollarse en esa profesión (estudiantes de derecho y abogados argentinos comprenderán 🤦).\n 
							 En 2019 renuncié a mi trabajo y decidí viajar a Francia con la visa de "vacaciones y trabajo" 🇫🇷. Fue la mejor experiencia de mi vida... hasta que el COVID apareció 🦠😷.  \n
							 La pandemia me obligó a volver a Argentina en diciembre del 2020. Desempleado y resuelto a no volver a trabajar en nada relacionado con el derecho 🙅, decidí reinventarme y meterme en ciencias de la computación, específicamente en desarrollo web 🖥️. \n
							 Siempre fui muy curioso y me interesó aprender sobre las cosas que no entendía, siendo las computadoras una de ellas. "Por qué no intentarlo?", lo peor que podía pasar era que terminase aprendiendo algo nuevo 🤓😆.\n
							 Empecé a estudiar de forma autodidacta al principio, y cuando me enteré del bootcamp intensivo de Soy Henry para desarrollo web me anoté, lo terminé y disfruté cada día de esos 4 meses geniales, donde además de aprender a programar, trabajé como Teaching Assistant 🧑‍🏫 y conocí a personas increíbles. Creo que fue una de las mejores decisiones que tomé en la vida hasta hoy. \n 
							 Actualmente, soy desarrollador web full stack 🧑‍💻 y me encanta lo que hago. No me visualizo haciendo otra cosa, es demasiado genial 😎, y sé que este es sólo el comienzo 🚀.`)
		}
	},
	projects: {
		description: "Algunos proyectos en los que estuve trabajando 🦾.",
		fn: () => {
			return (`✅ "Changas" 👷 - Link al sitio: https://changas.vercel.app/ \n
			
			'Changas' es una SPA intermediaria de servicios no profesionales que nuclea y conecta su demanda y oferta, similar a un "clasificados" digital pero mucho mejor. 
			Link repositorio --> https://github.com/mmiglioranza22/Changas \n
			
			✅ "Food recipes" 🍔 - Link al sitio: https://recipes-spa-project.vercel.app/ \n
			Mi primer proyecto. Fue uno de las tareas asignadas en el bootcamp de Soy Henry. Es un buscador de recetas de cocina.
			Link repositorio --> https://github.com/mmiglioranza22/recipes_SPA_project`

			)
		}
	},
	contact: {
		description: "Cómo ponerse en contacto 📫.",
		fn: () => {
			return (`Podés contactarme / encontrarme en los siguientes sitios 👇: \n
							 Email: 		mmiglioranza22@gmail.com 
							 LinkedIn:	https://www.linkedin.com/in/manuel-miglioranza-dev/ 
							 GitHub: 		https://github.com/mmiglioranza22 
							 `)
		}
	},
	tellmeajoke: {
		description: 'Espero te gusten los chistes malos 🙃. ',
		fn: () => {
			const arr = [
				`- ¿Sabes cómo se queda un mago después de comer? \n- Magordito.`,
				`- Buenos días, me gustaría alquilar "Batman Forever".\n- No es posible, tiene que devolverla tomorrow.`,
				`- ¿Qué le dice una iguana a su hermana gemela? \n- Somos iguanitas.`,
				`- Doctor, tengo todo el cuerpo cubierto de pelo. ¿Qué padezco? \n- Padece uzté un ozito.`,
				`- ¿Cómo se despiden los químicos? \n- Ácido un placer`,
				`- Una familia ocupó un terreno en Hawaii. Ahora a ver quién la desaloha.`,
				`La mamá le dice a la niña ciega: \n - Y si te vuelves a portar mal, te cambio los muebles de lugar.`,
				`- Mamá, en el colegio me dicen "Backstreet Boy". \n + Quién te dice así ? \n- Everybody...🎶 `,
				`- ¿Qué hace un leproso tocando la guitarra? \n- Carne picada.`,
				`- Que le pasa al hierro cuando se oxida? \n- Se pone FeO.`,
				`- Creo que Heisenberg murió virgen, pues cuando encontraba el momento no encontraba la posición...`,
				`-¿Qué es un terapeuta? \n- 1024 Gigapeutas.`,
				`- Sólo hay 10 tipos de personas en este bendito mundo, las que entienden binario y las que no.`
			]
			const i = Math.floor((Math.random() * arr.length))
			return arr[i]
		}
	},
}

export default function Spanish() {


	return (
		<div id="container" style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "10px" }} >
			<Terminal
				id='terminal'
				commands={commands}
				welcomeMessage={

					<Typewriter
						words={[`Hola 👋! \n
												Mi nombre es Manuel Miglioranza y soy desarrollador web full stack 🧑‍💻.
												Para saber un poco sobre mí y sobre los proyectos en los que trabajé, podés intectuar con esta terminal. \n
												Escribí "help" para comenzar y "clear" para limpiar la consola😁.`]}
						loop={1}
						cursor
						cursorStyle=''
						typeSpeed={20}
						delaySpeed={50}
					/>
				}
				promptLabel={'~$'}
				style={{ width: "50%", height: "700px", borderRadius: "3px", backgroundColor: "#1E1E1E" }}
				contentStyle={{ fontSize: "17px", color: "#f153f1", borderRadius: "3px", backgroundColor: "#1E1E1E" }}
				inputAreaStyle={{ color: "#22ff59", paddingBottom: "0px", marginBottom: "0px" }}
				promptLabelStyle={{ color: "#22ff59", paddingBottom: "0px", marginBottom: "0px" }}
				inputTextStyle={{ color: "timberwolf", fontSize: "17px", paddingTop: "2px", marginTop: "6px", marginBottom: "4px" }}
				messageStyle={{ color: "white", marginTop: "4px", marginBottom: "4px", paddingTop: "2px", paddingBottom: "2px" }}
			/>
		</div>
	)
}
